// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"2d2da583","361":"2d2da583","947":"be77114e"}[chunkId] + ".chunk.css";
};